import { addPeriodOfTime, getCurrentDateTime } from '../../../services/datetime-service';

const TwentyFourHours = { period: 'hours', value: 24 };

export const getHasDismissedBannerInThePast24Hrs = (lastDismissedDateTimeISO) => {
  const lastDismissalPlus24Hrs = addPeriodOfTime(lastDismissedDateTimeISO, TwentyFourHours);
  const now = getCurrentDateTime();
  const hasDismissedTheBannerInThePast24Hrs = lastDismissalPlus24Hrs > now;
  return hasDismissedTheBannerInThePast24Hrs;
};
